"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _UTTouchableWithoutFeedback = _interopRequireDefault(require("../../../UTTouchableWithoutFeedback"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var LegendContainer = function LegendContainer(_ref) {
  var index = _ref.index,
      currentSlide = _ref.currentSlide,
      onClick = _ref.onClick,
      LegendCustom = _ref.LegendCustom,
      classes = _ref.classes,
      keyName = _ref.keyName;

  var handleOnClick = function handleOnClick() {
    return onClick(index + 1);
  };

  var isActive = currentSlide === index;
  return LegendCustom ? _react["default"].createElement(LegendCustom, {
    onClick: handleOnClick
  }) : _react["default"].createElement(_UTTouchableWithoutFeedback["default"], {
    keyName: keyName,
    className: classes.legendStyleTouchable,
    onClick: handleOnClick
  }, _react["default"].createElement("div", {
    className: "".concat(classes.legendStyleContainer, " ").concat(isActive && classes.legendStyleIsActive)
  }));
};

LegendContainer.propTypes = {
  onClick: _propTypes.func,
  index: _propTypes.number,
  currentSlide: _propTypes.number,
  LegendCustom: _propTypes.node,
  keyName: _propTypes.string,
  classes: _propTypes.any // eslint-disable-line react/forbid-prop-types

};

var _default = (0, _react.memo)(LegendContainer);

exports["default"] = _default;